import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center mb-xs"
}
const _hoisted_2 = {
  key: 0,
  class: "text-gray-700 px-m"
}
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 w-full" }

import { computed, ref, onMounted } from "vue";
import { useManagedPatientsStore } from "@/store/managedPatientsStore";
import router from "@/router";
import { useRoute } from "vue-router";

import RoundedCard from "@/components/RoundedCard.vue";
import ProfileData from "../components/ProfileData.vue";
import PatientMedications from "../components/PatientMedications.vue";
import PatientFileManagement from "../components/PatientFileManagement.vue";
import PatientAddCareProviderGroup from "../components/PatientAddCareProviderGroup.vue";
import UmanaHeadline from "@/components/UmanaHeadline.vue";
import LabelButton from "@/components/LabelButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ManagedPatientView',
  setup(__props) {

const route = useRoute();

const managedPatientsStore = useManagedPatientsStore();
const fileover = ref<boolean>(false);
const managedPatient = computed(() => {
  let array = Array.from(managedPatientsStore.patients?.values() ?? []);
  let patient = array.find(
    (patient) => patient.id == parseInt(`${route.params.id}`)
  );
  return patient;
});

const managedPatientKey = computed(() => {
  if (managedPatient.value?.id && managedPatientsStore.keys) {
    let keys = Array.from(managedPatientsStore.keys.values());
    return keys.find(
      (key) => key.managed_patient_id == managedPatient.value?.id
    );
  }
  return null;
});

function goBack() {
  if (window.history.state.back != null) {
    router.go(-1);
    return;
  }

  router.push("/managedPatients");
}

onMounted(() => {
  if (managedPatient.value == undefined) {
    router.push("/managedPatients");
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (managedPatient.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(LabelButton, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack())),
            icon: "left",
            class: "items-center"
          }),
          _createVNode(UmanaHeadline, {
            h: "h1",
            class: "ml-s"
          }, {
            default: _withCtx(() => [
              (managedPatient.value.currentProfile?.deceased)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, " †"))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(managedPatient.value?.currentProfile?.firstName) + " " + _toDisplayString(managedPatient.value?.currentProfile?.lastName), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(RoundedCard, null, {
        default: _withCtx(() => [
          (managedPatient.value && managedPatientKey.value)
            ? (_openBlock(), _createBlock(ProfileData, {
                key: 0,
                "managed-patient": managedPatient.value,
                "managed-patient-key": managedPatientKey.value
              }, null, 8, ["managed-patient", "managed-patient-key"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(RoundedCard, null, {
        default: _withCtx(() => [
          (managedPatient.value && managedPatientKey.value)
            ? (_openBlock(), _createBlock(PatientMedications, {
                key: 0,
                "managed-patient": managedPatient.value,
                "managed-patient-key": managedPatientKey.value
              }, null, 8, ["managed-patient", "managed-patient-key"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(RoundedCard, {
        onDragleave: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (fileover.value = false), ["prevent"]))
      }, {
        default: _withCtx(() => [
          (managedPatient.value && managedPatientKey.value)
            ? (_openBlock(), _createBlock(PatientFileManagement, {
                key: 0,
                "managed-patient": managedPatient.value,
                "managed-patient-key": managedPatientKey.value
              }, null, 8, ["managed-patient", "managed-patient-key"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(RoundedCard, null, {
        default: _withCtx(() => [
          (managedPatient.value && managedPatientKey.value)
            ? (_openBlock(), _createBlock(PatientAddCareProviderGroup, {
                key: 0,
                "managed-patient": managedPatient.value,
                "managed-patient-key": managedPatientKey.value
              }, null, 8, ["managed-patient", "managed-patient-key"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})